export default {
  dismissed: false,
  dismissedAt: null,
  isOpen: false,
  isLoading: false,
  isError: false,
  hasData: false,
  errorMessage: "",
};
